import { RootState } from '../../store';

export const isFetchingLocation = (state: RootState) =>
  state.location?.isFetchingLocation;

export const getLocations = (state: RootState) => state.location.locations;

export const getCurrentLocation = (state: RootState) =>
  state.location.currentLocation;

export const getCurrentCity = (state: RootState) =>
  state.location.currentLocation?.cityName;

export const getCurrentCountry = (state: RootState) =>
  state.location.currentLocation?.country?.countryName;

export const getCurrentCityId = (state: RootState) =>
  state.location.currentLocation?.id;

export const getCitiesByCountry = (state: RootState) =>
  state.location.locationsByCountry?.content;

export const getCountryList = (state: RootState) => state.location.countryList;
